import store from '@/store'
function handle (el, binding) {
  const { value } = binding
  const roles = parseInt(store.getters.role)
  if (value && value instanceof Array && value.length > 0) {
    const permissionRoles = value
    const hasPermission = permissionRoles.some(role => {
      return roles === role
    })
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el)
    }
  } else {
    throw new Error(`error`)
  }
}
const permission = {
  inserted (el, binding) {
    // console.log(el)
    handle(el, binding)
  }
}

export default permission
